import { Component, Input, OnInit } from '@angular/core';
import { AlliancesService } from '@app/core/services/alliances.service';

@Component({
  selector: 'app-completed-form',
  templateUrl: './completed-form.component.html',
  styleUrls: ['./completed-form.component.css'],
})
export class CompletedFormComponent implements OnInit {
  @Input() infoLead: any;

  constructor(private srvAlliances: AlliancesService) {}

  ngOnInit(): void {
    this.infoLead = {
      name: '',
      contactEmail: '',
      contactName: '',
      contactPhone: '',
      city: '',
      section: '',
      arquetipo: '',
      firstContactDate: '',
    };
  }
}
